export class FiltrosInversionistas{

    IdProv : string = '';
    IdAdq : string = '';
    FechaIni : string = '';
    FechaFin : string = '';
    Moneda : number = 0;
}